import isPlainObject from "is-plain-obj";
import { reduce, uniqueId } from "lodash";

const localForage = new Map();

export function populateWithFiles(data: any): any {
  if (isPlainObject(data)) {
    return reduce(
      data,
      (acc, val, key) => ({
        ...acc,
        [key]: populateWithFiles(val),
      }),
      {}
    );
  } else if (
    typeof data === "string" &&
    (data.startsWith("file://") ||
      data.startsWith("date://") ||
      data.startsWith("filelist://"))
  ) {
    return localForage.get(data);
  }
  return data;
}

export function storeFilesInStorage(data: any): any {
  if (data instanceof FileList) {
    const ind = uniqueId();
    localForage.set(`filelist://${ind}`, data);
    return `filelist://${ind}`;
  } else if (data instanceof Date) {
    const ind = uniqueId();
    localForage.set(`date://${ind}`, data);
    return `date://${ind}`;
  } else if (data instanceof File) {
    const ind = uniqueId();
    localForage.set(`file://${ind}`, data);
    return `file://${ind}`;
  } else if (isPlainObject(data)) {
    return reduce(
      data,
      (acc, val, key) => ({
        ...acc,
        [key]: storeFilesInStorage(val),
      }),
      {}
    );
  } else if (Array.isArray(data)) {
    return data.map((x) => storeFilesInStorage(x));
  }
  return data;
}
